'use client';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { ProductBadge } from './product-badge';

export function ProductBottomInfo() {
  const { t } = useTranslations();
  const product = useVariantsStore(state => state.product);
  const selectedVariant = useVariantsStore(state => state.selectedVariant);

  const hasCategories = product.categories && product.categories?.length;

  return (
    <div className="flex w-full flex-wrap items-center justify-start gap-x-4 gap-y-2 sm:gap-x-6">
      {hasCategories && (
        <div className="flex flex-wrap items-center justify-start gap-2">
          <p className="text-[10px] font-normal tracking-tight text-[#666666] sm:text-xs">
            {t('text230')}
          </p>
          {product.categories?.map(category => (
            <ProductBadge
              key={category.name}
              background="#F1E4DE"
              color="#3E1C12"
              text={category.name}
            />
          ))}
        </div>
      )}
      <div className="flex flex-wrap items-center justify-start gap-2">
        <p className="text-[10px] font-normal tracking-tight text-[#666666] sm:text-xs">
          {t('text228')}
        </p>
        <p className="text-[10px] font-normal tracking-tight text-black sm:text-xs">
          {selectedVariant?.code ?? product?.code}
        </p>
      </div>
    </div>
  );
}
